import { Gauge, TrendingUp, ShieldCheck, Headset } from "lucide-react";
import { SectionEyebrow } from "@/components/ui/SectionEyebrow";

const panels = [
  {
    icon: Gauge,
    title: "Performance-Focused",
    body: "Infrastructure designed around responsive digital experiences and demanding workloads.",
  },
  {
    icon: TrendingUp,
    title: "Built to Scale",
    body: "Start with the resources you need and move to larger infrastructure as your requirements grow.",
  },
  {
    icon: ShieldCheck,
    title: "Security-Minded",
    body: "Security and network considerations should be integrated into every infrastructure decision.",
  },
  {
    icon: Headset,
    title: "Human Support",
    body: "Speak with a real infrastructure professional when you need help selecting or managing a solution.",
  },
];

export function WhyChooseUs() {
  return (
    <section id="why-the-planet" className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
      <div className="max-w-2xl">
        <SectionEyebrow>Why The Planet</SectionEyebrow>
        <h2 className="mt-5 font-display text-3xl font-semibold text-text-primary sm:text-4xl">
          Technology Should Help You Move Faster, Not Hold You Back
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {panels.map((p) => (
          <div key={p.title} className="rounded-card border border-border bg-navy-card p-6">
            <p.icon className="h-6 w-6 text-cyan" strokeWidth={1.6} />
            <h3 className="mt-4 font-display text-base font-semibold text-text-primary">
              {p.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-text-secondary">{p.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
